import { AxiosResponse } from "axios";
import { Auth, UserCredential } from "firebase/auth";
import { call, put } from "redux-saga/effects";
import { firebaseInitialize, firebaseSignIn } from "../../../../utils/firebase";
import { emailGetSignIn } from "../api";
import * as types from "../consts";

export function* emailPostRequestSaga({ payload }: ReturnType<typeof Object>) {
  try {
    const response: AxiosResponse = yield call(emailGetSignIn, payload);
    if (response) {
      yield put({ type: types.GET_SIGNIN_EMAIL_SUCCESS, response });
    } else {
      const error = { status: 500 };
      yield put({ type: types.GET_SIGNIN_EMAIL_ERROR, error });
    }
  } catch (error) {
    yield put({ type: types.GET_SIGNIN_EMAIL_ERROR, error });
  }
}

export function* firebaseInitializeSaga(
  signInState: ReturnType<typeof Object>
) {
  try {
    const response: AxiosResponse = yield call(emailGetSignIn, signInState.payload);
    const { tenantId } = response.data;
    const auth: Auth = firebaseInitialize(signInState.payload, tenantId);
    const signin: Promise<UserCredential> = yield call(
      firebaseSignIn,
      auth,
      signInState.payload.email,
      signInState.payload.password
    );
    yield put({ type: types.FIREBASE_SIGNIN_PWD_SUCCESS, signin });
  } catch (error) {
    yield put({ type: types.FIREBASE_SIGNIN_PWD_ERROR, error });
  }
}
